import { render, staticRenderFns } from "./EntitiesList.vue?vue&type=template&id=50784cb4&scoped=true"
import script from "./EntitiesList.vue?vue&type=script&lang=ts"
export * from "./EntitiesList.vue?vue&type=script&lang=ts"
import style0 from "./EntitiesList.vue?vue&type=style&index=0&id=50784cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50784cb4",
  null
  
)

export default component.exports